@if (showFeedback()) {
    <woa-link [link]="'woa.label.legal.feedback'" (onActivate)="feedback()"></woa-link>
    <div class="legal-text">{{ 'woa.message.' + messageSet() + '.legal.conjunction' | translate }}
    </div>
} @else {
    <div class="legal-text" [innerHTML]="('woa.message.' + messageSet() + '.legal.pre') | translate: messageParams() | html"></div>
}
<woa-link [link]="'woa.label.legal.terms'" (onActivate)="showAdminDetails('terms')"></woa-link>
<div class="legal-text">{{ 'woa.message.' + messageSet() + '.legal.conjunction' | translate }}</div>
<woa-link [link]="'woa.label.legal.privacy'" (onActivate)="showAdminDetails('privacy')"></woa-link>
@if (!showFeedback()) {
    <div class="legal-text">{{ 'woa.message.' + messageSet() + '.legal.post' | translate }}</div>
}
